"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.replace");
var _semanticsearch = require("@/api/semanticsearch");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: "SemanticSearch",
  data: function data() {
    return {
      query: "",
      items: [],
      total: 0,
      pageNum: 1,
      pageSize: 20,
      loading: false,
      searched: false,
      fallback: false,
      message: "",
      notImg: require("@/assets/404_images/notimg.png")
    };
  },
  created: function created() {
    var query = (this.$route.query.query || "").trim();
    if (query) {
      this.query = query;
      this.submitSearch();
    }
  },
  watch: {
    "$route.query.query": function $routeQueryQuery(value) {
      var query = (value || "").trim();
      if (query && query !== this.query) {
        this.query = query;
        this.pageNum = 1;
        this.submitSearch();
      }
    }
  },
  methods: {
    submitSearch: function submitSearch() {
      var query = (this.query || "").trim();
      if (!query) {
        this.$message.warning("请输入想查找的课程内容");
        return;
      }
      this.pageNum = 1;
      this.loadResults();
    },
    changePage: function changePage(page) {
      this.pageNum = page;
      this.loadResults();
      window.scrollTo({
        top: 260,
        behavior: "smooth"
      });
    },
    loadResults: function loadResults() {
      var _this = this;
      this.loading = true;
      (0, _semanticsearch.semanticSearch)({
        query: this.query.trim(),
        pageNum: this.pageNum,
        pageSize: this.pageSize
      }).then(function (res) {
        if (res.code !== 200) {
          return Promise.reject(new Error(res.msg || "语义搜索失败"));
        }
        var data = res.data || {};
        _this.items = data.items || [];
        _this.total = data.total || 0;
        _this.fallback = !!data.fallback;
        _this.message = data.message || "";
        _this.searched = true;
        var currentQuery = (_this.$route.query.query || "").trim();
        if (currentQuery !== _this.query.trim()) {
          _this.$router.replace({
            path: "/semanticSearch",
            query: {
              query: _this.query.trim()
            }
          });
        }
      }).catch(function (error) {
        _this.items = [];
        _this.total = 0;
        _this.searched = true;
        _this.$message.error(error.message || "语义搜索失败，请稍后重试");
      }).finally(function () {
        _this.loading = false;
      });
    },
    openItem: function openItem(item) {
      var link = item.courseLink || item.freeLink;
      if (link) {
        window.open(link, "_blank");
      } else {
        this.$message.info("该资源暂未提供访问地址");
      }
    },
    handleImageError: function handleImageError(event) {
      event.target.onerror = null;
      event.target.src = this.notImg;
    }
  }
};